import { createIntl, createIntlCache, IntlShape } from 'react-intl';
import intlFormats from '~/i18n/intl-formats';
import Logger from '~/utils/logger/logger';

const defaultOptions = {
  locale: 'en-US',
  defaultLocale: 'en-US',
  formats: intlFormats,
  textComponent: 'span' as const,
  messages: {},
};

type Subscription = (newIntl: IntlShape) => void;
interface Messages {
  [key: string]: string;
}

export class IntlWrapper {
  private static INTL_CACHE = createIntlCache();
  private subscribers: Subscription[] = [];

  public _intl: IntlShape = createIntl(
    { ...defaultOptions },
    IntlWrapper.INTL_CACHE
  );

  private notifySubscribers(newIntl: IntlShape): void {
    Logger.log(
      `Emitting Intl update to ${this.subscribers.length} subscriber(s)`
    );
    this.subscribers.forEach((s) => s(newIntl));
  }

  getIntl(): IntlShape {
    return this._intl;
  }

  updateIntl(messages: Messages, locale: string): IntlShape {
    Logger.log(
      `Updating intl with locale ${locale}. Number of messages:`,
      Object.keys(messages).length
    );

    this._intl = createIntl(
      {
        ...defaultOptions,
        locale: locale,
        defaultLocale: locale,
        messages,
      },
      IntlWrapper.INTL_CACHE
    );

    this.notifySubscribers(this._intl);
    return this._intl;
  }

  subscribe(cb: Subscription): void {
    this.subscribers.push(cb);
  }

  unsubscribe(cb: Subscription): void {
    this.subscribers = this.subscribers.filter((s) => s !== cb);
  }
}

export default IntlWrapper;
